import { render, staticRenderFns } from "./client-details-credit-card.vue?vue&type=template&id=7564a2c7&scoped=true"
import script from "./client-details-credit-card.vue?vue&type=script&lang=js"
export * from "./client-details-credit-card.vue?vue&type=script&lang=js"
import style0 from "./client-details-credit-card.vue?vue&type=style&index=0&id=7564a2c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7564a2c7",
  null
  
)

export default component.exports